import React, { useEffect, useState } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import $ from "jquery";
import ShowMoreText from "react-show-more-text";
import Chart from "react-apexcharts";
import ImageLoader from "../common/ImageLoader";
import { getCreatorKeyMetricsInfoWithOutAuth, getCreatorProfileInfoWithOutAuth, onCheckSocialAccounts, onSocialVerify } from '../../services';
import 'react-tabs/style/react-tabs.css';
import Close_black from "../../assets/close_black.svg";
import Close_white from "../../assets/white-close.svg";
import BackArrowWhite from "../../assets/back-arrow-white.svg";
import userImage from "../../assets/user-image.svg";
import socialIcon1 from "../../assets/insta-icon.svg";
import socialIcon2 from "../../assets/facebook-icon.svg";
import socialIcon3 from "../../assets/youtube-icon.svg";
import socialIcon4 from "../../assets/twitter-icon.svg";
import Profile_tooltip from "../../assets/tool-tip-mark.svg";
import shareIcon from "../../assets/share-icon.svg";
import footerLogo from "../../assets/josh-logo-footer.svg";
import Downarrow from "../../assets/down_arrow.svg";
import LogoHeader from '../common/LogoHeader';
import { codeConvert, decode, decryptResponse, duplicateValueMerge, encryptResponse, getYear, numberConversion, socialSection, socialSectionMetric, tagsConcat, viewPublisher2, viewPublisher3 } from '../../utils/common';
import { socialMediaColors } from '../../constants';
import { useHistory } from 'react-router-dom';
import IsLoadingHOC from '../HOC/loader/IsLoadingHOC';
import { useToast } from '../../toast';
import { EmailShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import { IS_VIEW_ABOUT_US, REGISTER_DETAILS } from '../../redux/action_type';
import { useDispatch, useSelector } from 'react-redux';
import { onJustReducerUpdate } from '../../redux/action';
import OtpInput from "react-otp-input";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import aboutSlider1 from "../../assets/about-1.svg";
import aboutSlider2 from "../../assets/about-2.svg";
import aboutSlider3 from "../../assets/about-3.svg";
import aboutSlider4 from "../../assets/about-4.svg";
import leftCoin from "../../assets/left-coin.svg";
import rightCoin from "../../assets/right-coin.svg";
import pinMark from "../../assets/pin-mark.svg";
import imgNoData from "../../assets/not-data-image-1.svg";
import aboutIocon2 from "../../assets/google-about.svg";
import aboutIocon3 from "../../assets/facebook-about.svg";

import { LoginSocialFacebook } from "reactjs-social-login";
import _ from "lodash";
import { GoogleLogin } from '@react-oauth/google';
function SocialPerformanceReport(props) {
    const { setLoading } = props;
    const [creatorDetail, setCreatorDetail] = useState([])
    const [newDetails, setNewDetails] = useState([]);
    const [details, setDetails] = useState({});
    const [series, setSeries] = useState([]);
    const [platformNames, setPlatformNames] = useState([]);
    const [platformColor, setPlatformColor] = useState([]);
    const [optionData, setOptionData] = useState([]);
    const [selectedOption, setSelectedOption] = useState([]);
    const [activeAudience, setActiveAudience] = useState(0);
    const [gender, setGender] = useState([50, 50]);
    const genderColor = ["#ed589d", "#9100eb"];
    const [content, setContent] = useState({})
    const [showContent, setShowContent] = useState(false)

    const history = useHistory();
    const toast = useToast();
    const dispatch = useDispatch()
    const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI
    const storageValue = localStorage.getItem("clientID")
    const client_id = JSON.parse(storageValue)?.client_id || ""
    const clientIDs = useSelector((state) => state.clientID || {})
    const [age, setAge] = useState({
        title: [],
        value: [],
    });
    const [city, setCity] = useState({
        title: [],
        value: [],
    });
    var auth2 = null

    useEffect(() => {
        window.gapi.load('auth2', function () {
            auth2 = window.gapi.auth2.init({
                client_id: process.env.REACT_APP_GG_APP_ID,
                cookiepolicy: 'single_host_origin',
                response_type: 'id_token permission',
                redirect_uri: REDIRECT_URI
            });
            attachSignin(document.getElementById('googleBtn'));
        });
    }, [clientIDs])

    function attachSignin(element) {
        auth2.attachClickHandler(element, {},
            function (googleUser) {
                const responseData = googleUser?.getAuthResponse()
                if (responseData) {
                    console.log("123googleUser", responseData)
                    onLoginResolve("GOOGLE", responseData?.id_token)
                }
            }, function (error) {
                console.log("123error", error, client_id || clientIDs?.client_id)
            });
    }
    useEffect(() => {
        if (!props.match.params.id) {
            return
        }
        const publish_id = props.match.params.id
        // onCheckSocialAccounts().then((res) => {
        //     console.log("123resres",res)
        //     setShowContent(res.status)
        // })
        setLoading(true)
        getCreatorKeyMetricsInfoWithOutAuth(publish_id).then((response) => {
            setContent(response)
            setLoading(false)
            if (response.status) {
                $("#social-popup").modal("show")
                setCreatorDetail(response.data[0])
                const connections = response.data.filter(a => {
                    let type = a.type
                    return a[type].Network == "youtube" ||
                        a[type].Network == "facebook" ||
                        a[type].Network == "instagram" ||
                        a[type].Network == "twitter"
                })
                let contructData = []
                let data = [...connections]
                data.map(val => {
                    let type = val.type
                    const valueKey = val[type]
                    contructData = [...contructData, {
                        Network: valueKey.Network,
                        AccountTitle: valueKey.ChannelName || valueKey.NetworkUser,
                        NetworkUser: valueKey.NetworkUser,
                        Followers: valueKey.Followers || valueKey.TotalSubscribers,
                        TotalPosts: valueKey.SocialEngagement[0].PostsCountLifetime,
                        EngagementFind: {
                            ...valueKey.SocialEngagement[0],
                            Network: valueKey.Network,
                            NetworkUser: valueKey.NetworkUser,
                            VideoInformation: valueKey.VideoInformation,
                            TotalVideos: valueKey.TotalVideos || null,
                            AVV30: valueKey.AVV30 || null,
                            TotalComments: valueKey.TotalComments || null,
                            NumberOfPosts: valueKey.NumberOfPosts,
                            TotalViews: valueKey.TotalViews || null
                        }
                    }]
                })
                setNewDetails(contructData)
            }
        }).catch((err) => {
            console.log("err", err)
            setLoading(false)
        })
        getCreatorProfileInfoWithOutAuth(publish_id).then(async (response) => {
            console.log("123response", response)
            setLoading(false)
            if (response.status) {
                const resp = await duplicateValueMerge(response.data);
                const accounts = resp[0]
                setShowContent(response?.data?.[0]?.linkedAccount || false)
                const connections = accounts.NewAccount.filter(
                    (a) =>
                        a.Network == "youtube" ||
                        a.Network == "facebook" ||
                        a.Network == "instagram" ||
                        a.Network == "twitter"
                );
                const engagement = accounts.Engagement;

                const newArray = [];

                for (let index = 0; index < connections.length; index++) {
                    const element = connections[index];
                    const engagementFind = engagement?.find(a => a.Network === element.Network && a.NetworkUser === element.NetworkUser);
                    let obj = {};

                    if (engagementFind) {
                        obj.engagementFind = engagementFind;
                        obj.engagementShow = true;
                    } else {
                        obj.engagementShow = false;
                    }

                    obj.Network = element.Network;
                    obj.AccountTitle = element.Title;
                    obj.AccountLogoURL = element.LogoURL;
                    obj.AccountNetworkUser = element.NetworkUser;
                    obj.AccountFollower = element.FollowersCount;
                    obj.Accounts = element.Accounts;
                    newArray.push(obj);
                }


                setDetails({ ...details, oldAccount: accounts, newAccount: newArray, actualAccount: accounts });

                let seriesCount = [];
                let tempColors = [];
                let tempPlatforms = [];
                for (let i = 0; i < accounts.Accounts.length; i++) {
                    seriesCount.push(accounts.Accounts[i].FollowersCount || 0);
                    tempColors.push(socialMediaColors[accounts.Accounts[i].key]);
                    tempPlatforms.push(accounts.Accounts[i].key);
                }
                setSeries(seriesCount);
                setPlatformColor(tempColors);
                setPlatformNames(tempPlatforms);
            }
        }).catch((err) => setLoading(false));



    }, [])
    const onLoginResolve = (provider, id_token, code_token = "") => {
        let payload = {
            "client_id": client_id || clientIDs?.client_id || "",
            "country_code": "",
            "mobile_no": "",
            "otp": "",
            "token": encryptResponse(id_token),
            "user_auth_type": provider?.toUpperCase()
        }
        if (provider?.toUpperCase() === "APPLE") {
            payload = { ...payload, authorizationCode: code_token }
        }
        onSocialVerify(payload).then((res) => {
            if (res.status) {
                if (payload?.user_auth_type === "GOOGLE") {
                    window?.google?.accounts?.id?.revoke(res?.data?.gid, done => {
                        console.log("revoke", done.error);
                    });
                }
                $("#aboutus-modal").modal("hide");
                dispatch(onJustReducerUpdate(res.data, REGISTER_DETAILS))
                localStorage.setItem(REGISTER_DETAILS, JSON.stringify(res.data))
                history.push("/dashboards");
            }
        })
    }
    useEffect(() => {
        if (details?.actualAccount?.FlatAudience) {
            let name = Object.keys(details?.actualAccount.FlatAudience)[0];
            let tempOptions = [];
            Object.keys(details?.actualAccount.FlatAudience)
                .filter((item) => item != "TikTok")
                .filter((item) => item === "Instagram")
                .forEach((item, index) => {
                    let obj = {
                        value: item,
                        name: details?.actualAccount.FlagshipPropertyTitle
                    };
                    tempOptions.push(obj);
                });
            setSelectedOption(tempOptions[0]);
            setOptionData(tempOptions);
            updateValues(name);
        }

    }, [details?.actualAccount])

    const options = {
        noData: {
            text: "Data not Available",
            align: "center",
            verticalAlign: "middle",
            offsetX: 0,
            offsetY: 0,
            style: {
                color: "red",
                fontSize: "14px",
            },
        },
        fill: {
            colors: [function ({ value, seriesIndex, w }) {
                const account = details?.actualAccount?.Accounts.find(a => a.FollowersCount === value);
                if (account) {
                    return socialMediaColors[account.key];
                } else {
                    return '#D9534F'
                }
            }]
        },
        style: {
            backgroundColor: "red",
        },
        tooltip: {
            enabled: true,
            marker: {
                show: true,
                fill: {
                    colors: platformColor,
                },
            },
            fill: {
                colors: platformColor,
            },
            y: {
                formatter: function (value) {
                    let temp = numberConversion(value);
                    return temp;
                },
            },
        },

        labels: platformNames,
        plotOptions: {
            pie: {
                expandOnClick: true,
                donut: {
                    size: "50%",
                    labels: {
                        show: true,
                        name: {
                            // show: true,
                            offsetY: 15,
                            fontSize: "10px",
                            fontWeight: 200,
                            // fontFamily:"nano sans",
                            color: "#757575",
                            formatter: () => "Connections",
                        },
                        value: {
                            show: true,
                            fontSize: "14px",
                            // fontFamily: 'Nano Sans',
                            fontWeight: 600,
                            color: "white",
                            offsetY: -20,
                        },
                        total: {
                            show: true,
                            showAlways: true,
                            fontSize: "11px",
                            label: "Connections",
                            fontFamily: "Helvetica, Arial, sans-serif",
                            fontWeight: 600,
                            color: "white",
                            formatter: function (val) {
                                const addnumber = val.globals.series;
                                let sum = 0;
                                for (let i = 0; i < addnumber.length; i++) {
                                    sum = sum + addnumber[i];
                                }
                                return numberConversion(sum);
                            },
                        },
                        dataLabels: {
                            fill: {
                                colors: platformColor,
                            },
                        },
                    },
                },
            },
        },
        legend: {
            show: false,
            showForSingleSeries: false,
        },
    };
    const updateValues = (name) => {
        //--------target to get the array to get all the values---------
        let target = details?.actualAccount?.FlatAudience[name][0];
        //-------genderTarget to get the array to get data related to gender-------
        let genderTarget = target.Items.filter((item) => item.Type === "Sex")[0];
        // target.Items.filter((item) => item.Type === "Sex")[0].Item1.Value
        let genderPercentage = [...gender]
        Object.keys(genderTarget)?.map(b => {
            if ((b == "Item1" || b == "Item2")) {
                let val = genderTarget[b]
                if (val?.Title === "Female") {
                    genderPercentage[0] = genderTarget[b]?.Value
                } else if (val?.Title === "Male") {
                    genderPercentage[1] = genderTarget[b]?.Value
                }
            }
        })
        setGender(genderPercentage);
        //-------ageTarget to get the array to get data related to age-------
        let ageTarget = target.Items.filter(
            (item) => item.Type === "CombinedAge"
        )[0];
        // delete ageTarget.All;
        const constructObj = Object.values(ageTarget)?.filter(a => typeof a === "object" && a !== null)
        setAge({
            // ...age,
            value: [
                constructObj?.find((item) => item.Title === "< 18")?.Value,
                constructObj?.find((item) => item.Title === "18-24")?.Value,
                constructObj?.find((item) => item.Title === "25-34")?.Value,
                constructObj?.find((item) => item.Title === "35-44")?.Value,
                constructObj?.find((item) => item.Title === "45-64")?.Value,
                constructObj?.find((item) => item.Title === "65-")?.Value,
            ].filter(val => val !== undefined),
            title: [
                constructObj?.find((item) => item.Title === "< 18")?.Title,
                constructObj?.find((item) => item.Title === "18-24")?.Title,
                constructObj?.find((item) => item.Title === "25-34")?.Title,
                constructObj?.find((item) => item.Title === "35-44")?.Title,
                constructObj?.find((item) => item.Title === "45-64")?.Title,
                constructObj?.find((item) => item.Title === "65-")?.Title,
            ].filter(val => val !== undefined),
        });

        //-------flagsTarget to get the array to get data related to flags-------
        let flagTarget = target.Items.filter((item) => item.Type === "Countries")[0];
        let newFlag = [];
        for (let i = 1; i <= 5 && i <= Object.keys(flagTarget).length - 2; i++) {
            newFlag.push(flagTarget[`Item${i}`]);
        }
        setCity({
            value: newFlag.map(a => a.Value).filter(val => val !== undefined),
            title: newFlag.map(a => a.ShortName || a.Title).filter(val => val !== undefined),
        })
        setActiveAudience(
            details?.actualAccount?.FlatAudience["Instagram"]?.[0].Info.AudienceCredibility
        );
    };
    const series2 = [
        {
            name: "Age",
            data: age.value,
        },
    ];
    const options2 = {
        chart: {
            type: "bar",
            height: 350,
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "20%",
                endingShape: "rounded",
                borderRadius: 5,
            },
        },
        dataLabels: {
            enabled: false,

        },
        stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
        },
        xaxis: {
            categories: age.title,
        },
        yaxis: {
            labels: {
                formatter: (value) => {
                    return value + "%";
                },
            },
        },
        fill: {
            opacity: 1,
        },
        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex }) {
                return (
                    '<div className="arrow_box p-2">' +
                    "<span><b>Age</b> " +
                    series[seriesIndex][dataPointIndex] +
                    "%</span>" +
                    "</div>"
                );
            },
        },
    };
    const genderOptions = {
        chart: {
            width: 600,
            type: "pie",
        },
        dataLabels: {
            enabled: true,
            offset: -40,
            style: {
                colors: ['#fff2cc'],
                textShadow: false,
                textOutline: false,
            },
            dropShadow: {
                enabled: false,
            },
            // minAngleToShowLabel: 25
            background: {
                enabled: true,
                foreColor: '#000',
                borderRadius: 2,
                padding: 4,
                dropShadow: 'false',
            },

        },
        tooltip: {
            enabled: false
        },
        colors: genderColor,
        labels: ["Female", "Male"],
        legend: {
            show: true,
            position: "bottom",
            marker: {
                colors: genderColor,
            },
        },
    };
    const series3 = [
        {
            name: "Countries",
            data: city.value,
        },
    ];
    const options3 = {
        chart: {
            type: "bar",
            height: 350,
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "40%",
                endingShape: "rounded",
                borderRadius: 4,
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
        },
        xaxis: {
            categories: city.title,
        },
        yaxis: {
            labels: {
                formatter: (value) => {
                    return value + "%";
                },
            },
        },
        fill: {
            opacity: 1,
        },
        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex }) {
                return (
                    '<div className="arrow_box p-2">' +
                    "<span><b>City</b> " +
                    series[seriesIndex][dataPointIndex] +
                    "%</span>" +
                    "</div>"
                );
            },
        },
    };

    const firstHeadingTitle = (network) => {
        switch (network) {
            case "instagram":
                return {
                    heading: (
                        <p>
                            Total <br />
                            Followers
                        </p>
                    ),
                };
            case "youtube":
                return {
                    heading: (
                        <p>
                            Subscribes <br />{" "}
                        </p>
                    ),
                };
            case "facebook":
                return {
                    heading: (
                        <p>
                            Page <br />
                            Likes
                        </p>
                    ),
                };
            case "twitter":
                return {
                    heading: (
                        <p>
                            Followers <br />{" "}
                        </p>
                    ),
                };
        }
    };

    const engagementSection = (account) => {
        const socialPriority = (network, keyValue) => {
            if (account?.[`${keyValue}90Days`]) {
                return "90Days";
            }
            if (account?.[`${keyValue}60Days`]) {
                return "60Days";
            }
            if (account?.[`${keyValue}30Days`]) {
                return "30Days";
            }
            if (account?.[`${keyValue}20Posts`]) {
                return "20Posts";
            }
            if (account?.[`${keyValue}Lifetime`]) {
                return "Life time"
            }
            if (account?.[`${keyValue}90`]) {
                return "90Days";
            }
            if (account?.[`${keyValue}60`]) {
                return "60Days";
            }
            if (account?.[`${keyValue}30`]) {
                return "30Days";
            }
        };
        const engagementPriority = (value, type) => {
            if (value === "90Days") {
                return type === "number"
                    ? (account?.EngagementRate90Days * 100).toFixed(2)
                    : "90 days";
            } else if (value === "60Days") {
                return type === "number"
                    ? (account?.EngagementRate60Days * 100).toFixed(2)
                    : "60 days";
            } else if (value === "30Days") {
                return type === "number"
                    ? (account?.EngagementRate30Days * 100).toFixed(2)
                    : "30 days";
            } else if (value === "20Posts") {
                return type === "number"
                    ? (account?.EngagementRate20Posts * 100).toFixed(2)
                    : "20 posts";
            } else if (value === "Life time") {
                return type === "number"
                    ? (account?.EngagementRateLifetime * 100).toFixed(2)
                    : "20 posts";
            }
        };

        const likesPerPostPriority = (value, type) => {
            if (value === "90Days") {
                return type === "number"
                    ? account?.LikesPerPost90Days.toFixed(2)
                    : "90 days";
            } else if (value === "60Days") {
                return type === "number"
                    ? account?.LikesPerPost60Days.toFixed(2)
                    : "60 days";
            } else if (value === "30Days") {
                return type === "number"
                    ? account?.LikesPerPost30Days.toFixed(2)
                    : "30 days";
            } else if (value === "20Posts") {
                return type === "number"
                    ? account?.LikesPerPost20Posts.toFixed(2)
                    : "20 post";
            } else if (value === "Life time") {
                return type === "number"
                    ? account?.LikesPerPostLifetime.toFixed(2)
                    : "Life time";
            }
        };

        const commentsPerPostPriority = (value, type) => {
            if (value === "90Days") {
                return type === "number"
                    ? account?.CommentsPerPost90Days.toFixed(2)
                    : "90 days";
            } else if (value === "60Days") {
                return type === "number"
                    ? account?.CommentsPerPost60Days.toFixed(2)
                    : "60 days";
            } else if (value === "30Days") {
                return type === "number"
                    ? account?.CommentsPerPost30Days.toFixed(2)
                    : "30 days";
            } else if (value === "20Posts") {
                return type === "number"
                    ? account?.CommentsPerPost20Posts.toFixed(2)
                    : "20 post";
            } else if (value === "Life time") {
                return type === "number"
                    ? account?.CommentsPerPostLifetime.toFixed(2)
                    : "Life time";
            }
        };

        const sharesPerPostPriority = (value, type) => {
            if (value === "90Days") {
                return type === "number"
                    ? account?.SharesPerPost90Days.toFixed(2)
                    : "90 days";
            } else if (value === "60Days") {
                return type === "number"
                    ? account?.SharesPerPost60Days.toFixed(2)
                    : "60 days";
            } else if (value === "30Days") {
                return type === "number"
                    ? account?.SharesPerPost30Days.toFixed(2)
                    : "30 days";
            } else if (value === "20Posts") {
                return type === "number"
                    ? account?.SharesPerPost20Posts.toFixed(2)
                    : "20 post";
            } else if (value === "Life time") {
                return type === "number"
                    ? account?.SharesPerPostLifetime.toFixed(2)
                    : "Life time";
            }
        };

        const viewsPerPostPriority = (value, type) => {
            if (value === "90Days") {
                return type === "number"
                    ? account?.ViewsPerPost90Days.toFixed(2)
                    : "90 days";
            } else if (value === "60Days") {
                return type === "number"
                    ? account?.ViewsPerPost60Days.toFixed(2)
                    : "60 days";
            } else if (value === "30Days") {
                return type === "number"
                    ? account?.ViewsPerPost30Days.toFixed(2)
                    : "30 days";
            } else if (value === "20Posts") {
                return type === "number"
                    ? account?.ViewsPerPost20Posts.toFixed(2)
                    : "20 post";
            } else if (value === "Life time") {
                return type === "number"
                    ? account?.ViewsPerPostLifetime.toFixed(2)
                    : "Life time";
            }
        };

        const avgMonthlyViews = (value, type) => {
            if (value === "90Days") {
                return type === "number"
                    ? account?.AVV90?.toFixed(2)
                    : "90 days";
            } else if (value === "60Days") {
                return type === "number"
                    ? account?.AVV60?.toFixed(2)
                    : "60 days";
            } else if (value === "30Days") {
                return type === "number"
                    ? account?.AVV30?.toFixed(2)
                    : "30 days";
            }
        };

        const headingSection1 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Total <br />
                                Post
                            </p>
                        ),
                        tooltip: null,
                        subheading: numberConversion(account?.NumberOfPosts) || "N/A",
                    };
                case "twitter":
                    return {
                        heading: (
                            <p>
                                Total <br />
                                Tweets
                            </p>
                        ),
                        tooltip: null,
                        subheading: numberConversion(account?.NumberOfPosts) || "N/A",
                    };
                case "youtube":
                    return {
                        heading: (
                            <p>
                                Total <br />
                                Views
                            </p>
                        ),
                        tooltip: null,
                        subheading:
                            numberConversion(account?.TotalViews, "number") || "N/A",
                    };
                case "facebook":
                    return {
                        heading: (
                            <p>
                                Engagement <br />
                                Rate
                            </p>
                        ),
                        tooltip: socialPriority(account.Network, "EngagementRate") ? (

                            <div className="key-metric-tooltip">
                                <img
                                    aria-expanded="false"
                                    aria-hidden="true"
                                    id="metric-dropdown"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    src={Profile_tooltip}
                                    alt=""
                                />
                                <div className="right_tooltip">
                                    <div
                                        className="dropdown-menu  dropdown-toggle"
                                        aria-labelledby="metric-dropdown"
                                    >
                                        <a href="javascript:void(0);">
                                            [Based on last] {" "}
                                            {engagementPriority(
                                                socialPriority(account.Network, "EngagementRate"),
                                                "text"
                                            )}
                                        </a>
                                    </div>
                                </div>
                            </div>

                        ) : null,
                        subheading: `${socialPriority(account.Network, "EngagementRate") ? `${numberConversion(
                            engagementPriority(socialPriority(account.Network, "EngagementRate"), "number") || "N/A"
                        )} %` : "N/A"}`,
                    };
            }
        };

        const headingSection2 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Engagement <br />
                                Rate
                            </p>
                        ),
                        tooltip: socialPriority(account.Network, "EngagementRate") ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {engagementPriority(socialPriority(account.Network, "EngagementRate"), "text")}
                            </a>
                        ) : null,
                        subheading: `${socialPriority(account.Network, "EngagementRate") ? `${numberConversion(
                            engagementPriority(socialPriority(account.Network, "EngagementRate"), "number") || 0
                        )} %` : "N/A"}`,
                    };
                case "twitter":
                    return {
                        heading: (
                            <p>
                                Engagement <br />
                                Rate
                            </p>
                        ),
                        tooltip: socialPriority(account.Network, "EngagementRate") ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {engagementPriority(socialPriority(account.Network, "EngagementRate"), "text")}
                            </a>
                        ) : null,
                        subheading: `${socialPriority(account.Network, "EngagementRate") ? `${numberConversion(
                            engagementPriority(socialPriority(account.Network, "EngagementRate"), "number") || 0
                        )} %` : "N/A"} `,
                    };
                case "youtube":
                    return {
                        heading: (
                            <p>
                                Engagement <br />
                                Rate
                            </p>
                        ),
                        tooltip: socialPriority(account.Network, "EngagementRate") ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {engagementPriority(socialPriority(account.Network, "EngagementRate"), "text")}
                            </a>
                        ) : null,
                        subheading: `${socialPriority(account.Network, "EngagementRate") ? `${numberConversion(
                            engagementPriority(socialPriority(account.Network, "EngagementRate"), "number") || 0
                        )} %` : "N/A"}`,
                    };
                case "facebook":
                    return {
                        heading: (
                            <p>
                                Like <br />
                                Per Post
                            </p>
                        ),
                        tooltip: numberConversion(
                            likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading:
                            numberConversion(
                                likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                            ) || "N/A",
                    };
            }
        };
        const headingSection3 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Likes <br />
                                Per Post
                            </p>
                        ),
                        tooltip: numberConversion(
                            likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading:
                            numberConversion(
                                likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                            ) || "N/A",
                    };
                case "twitter":
                    return {
                        heading: (
                            <p>
                                Favourites <br />
                                per tweet
                            </p>
                        ),
                        tooltip: numberConversion(
                            likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading:
                            numberConversion(
                                likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                            ) || "N/A",
                    };
                case "youtube":
                    return {
                        heading: (
                            <p>
                                Views <br />
                                per video
                            </p>
                        ),
                        tooltip: numberConversion(
                            viewsPerPostPriority(socialPriority(account.Network, "ViewsPerPost"), "number") ||
                            0
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last]
                                {viewsPerPostPriority(socialPriority(account.Network, "ViewsPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading: numberConversion(
                            viewsPerPostPriority(socialPriority(account.Network, "ViewsPerPost"), "number") ||
                            0
                        ) || "N/A",
                    };
                case "facebook":
                    return {
                        heading: (
                            <p>
                                Comments <br />
                                per post
                            </p>
                        ),
                        tooltip: numberConversion(
                            commentsPerPostPriority(
                                socialPriority(account.Network, "CommentsPerPost"),
                                "number"
                            )
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {commentsPerPostPriority(
                                    socialPriority(account.Network, "CommentsPerPost"),
                                    "text"
                                )}
                            </a>
                        ) : null,
                        subheading: numberConversion(
                            commentsPerPostPriority(
                                socialPriority(account.Network, "CommentsPerPost"),
                                "number"
                            )
                        ) || "N/A",
                    };
            }
        };
        const headingSection4 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Comments <br />
                                per post
                            </p>
                        ),
                        tooltip: numberConversion(
                            commentsPerPostPriority(
                                socialPriority(account.Network, "CommentsPerPost"),
                                "number"
                            )
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {commentsPerPostPriority(
                                    socialPriority(account.Network, "CommentsPerPost"),
                                    "text"
                                )}
                            </a>
                        ) : null,
                        subheading: numberConversion(
                            commentsPerPostPriority(
                                socialPriority(account.Network, "CommentsPerPost"),
                                "number"
                            )
                        ) || "N/A",
                    };
                case "twitter":
                    return {
                        heading: (
                            <p>
                                Retweet <br />
                                per tweet
                            </p>
                        ),
                        tooltip: numberConversion(
                            sharesPerPostPriority(
                                socialPriority(account.Network, "SharesPerPost"),
                                "number"
                            )
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {sharesPerPostPriority(socialPriority(account.Network, "SharesPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading: numberConversion(
                            sharesPerPostPriority(
                                socialPriority(account.Network, "SharesPerPost"),
                                "number"
                            )
                        ) || "N/A",
                    };
                case "youtube":
                    return {
                        heading: (
                            <p>
                                Likes <br />
                                per video
                            </p>
                        ),
                        tooltip: numberConversion(
                            likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading:
                            numberConversion(
                                likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                            ) || "N/A",
                    };
                case "facebook":
                    return {
                        heading: (
                            <p>
                                Shares <br />
                                per post
                            </p>
                        ),
                        tooltip: numberConversion(
                            sharesPerPostPriority(
                                socialPriority(account.Network, "SharesPerPost"),
                                "number"
                            )
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {sharesPerPostPriority(socialPriority(account.Network, "SharesPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading: numberConversion(
                            sharesPerPostPriority(
                                socialPriority(account.Network, "SharesPerPost"),
                                "number"
                            )
                        ) || "N/A",
                    };
            }
        };
        const headingSection5 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Total <br />  Video
                            </p>
                        ),
                        tooltip: null,
                        subheading: account?.VideoInformation?.TotalVideos ? numberConversion(account?.VideoInformation?.TotalVideos) : "N/A",
                    };
                case "twitter":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
                case "youtube":
                    return {
                        heading: (
                            <p>
                                Comments <br /> Per Video
                            </p>
                        ),
                        tooltip: numberConversion(
                            commentsPerPostPriority(socialPriority(account.Network, "CommentsPerPost"), "number")
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {commentsPerPostPriority(socialPriority(account.Network, "CommentsPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading:
                            numberConversion(
                                commentsPerPostPriority(socialPriority(account.Network, "CommentsPerPost"), "number")
                            ) || "N/A",
                    };
                case "facebook":
                    return {
                        heading: (
                            <p>
                                Talking <br />
                                About
                            </p>
                        ),
                        tooltip: null,
                        subheading: account?.TotalComments ? numberConversion(account?.TotalComments) : "N/A",
                    };
            }
        };

        const headingSection6 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Total <br /> Views
                            </p>
                        ),
                        tooltip: null,
                        subheading: account?.VideoInformation?.TotalViews ? numberConversion(account?.VideoInformation?.TotalViews) : "N/A",
                    };
                case "twitter":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
                case "youtube":
                    return {
                        heading: (
                            <p>
                                Total <br /> Video
                            </p>
                        ),
                        tooltip: null,
                        subheading: account?.TotalVideos ? numberConversion(account?.TotalVideos) : "N/A",
                    };
                case "facebook":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
            }
        };

        const headingSection7 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Views<br />
                                Per Video
                            </p>
                        ),
                        tooltip: null,
                        subheading: account?.VideoInformation?.AvgLastViewsPerVideo ? numberConversion(account?.VideoInformation?.AvgLastViewsPerVideo) : "N/A",
                    };
                case "twitter":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
                case "youtube":
                    return {
                        heading: (
                            <p>
                                Avg<br />
                                Monthly Views
                            </p>
                        ),
                        tooltip: numberConversion(
                            avgMonthlyViews(socialPriority(account.Network, "AVV"), "number")
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {avgMonthlyViews(socialPriority(account.Network, "AVV"), "text")}
                            </a>
                        ) : null,
                        subheading: numberConversion(
                            avgMonthlyViews(socialPriority(account.Network, "AVV"), "number")
                        ) || "N/A",
                    };
                case "facebook":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
            }
        };
        const headingSection8 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Likes<br />
                                Per Video
                            </p>
                        ),
                        tooltip: null,
                        subheading: account?.VideoInformation?.AvgLastLikesPerVideo ? numberConversion(account?.VideoInformation?.AvgLastLikesPerVideo) : "N/A",
                    };
                case "twitter":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
                case "youtube":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
                case "facebook":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
            }
        };
        const headingSection9 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Comments<br />
                                Per Video
                            </p>
                        ),
                        tooltip: null,
                        subheading: account?.VideoInformation?.AvgLastCommentsPerVideo ? numberConversion(account?.VideoInformation?.AvgLastCommentsPerVideo) : "N/A",
                    };
                case "twitter":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
                case "youtube":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
                case "facebook":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
            }
        };
        return (
            <>
                <div className="key-metric-card">
                    {headingSection1().heading}
                    {headingSection1().tooltip}
                    <b>{headingSection1().subheading}</b>
                </div>
                <div className="key-metric-card">


                    {headingSection2(account).heading}
                    {headingSection2(account).tooltip && <div className="key-metric-tooltip">
                        <img
                            aria-expanded="false"
                            aria-hidden="true"
                            id="metric-dropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            src={Profile_tooltip}
                            alt=""
                        />
                        <div className="right_tooltip">
                            <div
                                className="dropdown-menu  dropdown-toggle"
                                aria-labelledby="metric-dropdown"
                            >
                                {headingSection2(account).tooltip}
                            </div>
                        </div>
                    </div>}
                    <b>{headingSection2(account).subheading}</b>
                </div>
                <div className="key-metric-card">


                    {headingSection3(account).heading}
                    {headingSection3(account).tooltip && <div className="key-metric-tooltip">
                        <img
                            aria-expanded="false"
                            aria-hidden="true"
                            id="metric-dropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            src={Profile_tooltip}
                            alt=""
                        />
                        <div className="right_tooltip">
                            <div
                                className="dropdown-menu  dropdown-toggle"
                                aria-labelledby="metric-dropdown"
                            >
                                {headingSection3(account).tooltip}
                            </div>
                        </div>
                    </div>}
                    <b>{headingSection3(account).subheading}</b>
                </div>
                <div className="key-metric-card">


                    {headingSection4(account).heading}
                    {headingSection4(account).tooltip && <div className="key-metric-tooltip">
                        <img
                            aria-expanded="false"
                            aria-hidden="true"
                            id="metric-dropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            src={Profile_tooltip}
                            alt=""
                        />
                        <div className="right_tooltip">
                            <div
                                className="dropdown-menu  dropdown-toggle"
                                aria-labelledby="metric-dropdown"
                            >
                                {headingSection4(account).tooltip}
                            </div>
                        </div>
                    </div>}
                    <b>{headingSection4(account).subheading}</b>
                </div>
                {headingSection5(account).heading && <div className="key-metric-card">
                    {headingSection5(account).heading}
                    {headingSection5(account).tooltip &&
                        <div className="key-metric-tooltip">
                            <img
                                aria-expanded="false"
                                aria-hidden="true"
                                id="metric-dropdown"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                src={Profile_tooltip}
                                alt=""
                            />
                            <div className="right_tooltip">
                                <div
                                    className="dropdown-menu  dropdown-toggle"
                                    aria-labelledby="metric-dropdown"
                                >
                                    {headingSection5(account).tooltip}
                                </div>
                            </div>
                        </div>
                    }
                    <b>{headingSection5(account).subheading}</b>
                </div>}
                {headingSection6(account).heading && <div className="key-metric-card">
                    {headingSection6(account).heading}
                    {headingSection6(account).tooltip &&
                        <div className="key-metric-tooltip">
                            <img
                                aria-expanded="false"
                                aria-hidden="true"
                                id="metric-dropdown"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                src={Profile_tooltip}
                                alt=""
                            />
                            <div className="right_tooltip">
                                <div
                                    className="dropdown-menu  dropdown-toggle"
                                    aria-labelledby="metric-dropdown"
                                >
                                    {headingSection6(account).tooltip}
                                </div>
                            </div>
                        </div>
                    }
                    <b>{headingSection6(account).subheading}</b>
                </div>}
                {headingSection7(account).heading && <div className="key-metric-card">
                    {headingSection7(account).heading}
                    {headingSection7(account).tooltip &&
                        <div className="key-metric-tooltip">
                            <img
                                aria-expanded="false"
                                aria-hidden="true"
                                id="metric-dropdown"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                src={Profile_tooltip}
                                alt=""
                            />
                            <div className="right_tooltip">
                                <div
                                    className="dropdown-menu  dropdown-toggle"
                                    aria-labelledby="metric-dropdown"
                                >
                                    {headingSection7(account).tooltip}
                                </div>
                            </div>

                        </div>}
                    <b>{headingSection7(account).subheading}</b>
                </div>}
                {headingSection8(account).heading && <div className="key-metric-card">
                    {headingSection8(account).heading}
                    {headingSection8(account).tooltip &&
                        <div className="key-metric-tooltip">
                            <img
                                aria-expanded="false"
                                aria-hidden="true"
                                id="metric-dropdown"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                src={Profile_tooltip}
                                alt=""
                            />
                            <div className="right_tooltip">
                                <div
                                    className="dropdown-menu  dropdown-toggle"
                                    aria-labelledby="metric-dropdown"
                                >
                                    {headingSection8(account).tooltip}
                                </div>
                            </div>

                        </div>}
                    <b>{headingSection8(account).subheading}</b>
                </div>}
                {headingSection9(account).heading && <div className="key-metric-card">
                    {headingSection9(account).heading}
                    {headingSection9(account).tooltip &&
                        <div className="key-metric-tooltip">
                            <img
                                aria-expanded="false"
                                aria-hidden="true"
                                id="metric-dropdown"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                src={Profile_tooltip}
                                alt=""
                            />
                            <div className="right_tooltip">
                                <div
                                    className="dropdown-menu  dropdown-toggle"
                                    aria-labelledby="metric-dropdown"
                                >
                                    {headingSection9(account).tooltip}
                                </div>
                            </div>
                        </div>
                    }
                    <b>{headingSection9(account).subheading}</b>
                </div>}
            </>
        );
    };
    const onGoBack = () => {
        $("#social-popup").modal("hide")
        history.goBack()
    }
    const onCopyLink = () => {
        console.log('Trigger');
        navigator.clipboard.writeText(window.location.href);
        toast.open("Link copied successfully");
    }
    const onRedirect = () => {
        window.open("/", '_blank');
    }

    return (
        <>
            <LogoHeader />
            <div className='social-performance-wrap performance-report-page'>
                {/* Social Performance Report Popup Start Here */}
                <div
                    className="modal fade show"
                    tabIndex="-1"
                    aria-labelledby="exampleModalLabel"
                    data-backdrop="static"
                    data-keyboard="false"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered custom-popup" role="document">
                        <div className="modal-content   ">
                            <div className="modal-header">
                                <div className='social-header'>
                                    <h5 className="modal-title" id="exampleModalLabel">
                                        {/* <img onClick={onGoBack} src={BackArrowWhite} alt="" /> */}
                                        <span>Social Performance Report</span>
                                    </h5>
                                    {/* <div className="share-btn-wrap">
                                        <button
                                            className="dropdown-toggle"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                        >
                                            Share Link
                                            <svg className='share-icon' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4 10C5.10457 10 6 9.10457 6 8C6 6.89543 5.10457 6 4 6C2.89543 6 2 6.89543 2 8C2 9.10457 2.89543 10 4 10Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M11 14.5C12.1046 14.5 13 13.6046 13 12.5C13 11.3954 12.1046 10.5 11 10.5C9.89543 10.5 9 11.3954 9 12.5C9 13.6046 9.89543 14.5 11 14.5Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M11 5.5C12.1046 5.5 13 4.60457 13 3.5C13 2.39543 12.1046 1.5 11 1.5C9.89543 1.5 9 2.39543 9 3.5C9 4.60457 9.89543 5.5 11 5.5Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M9.31929 4.58203L5.68359 6.91926" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M5.68359 9.08203L9.31929 11.4193" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <a data-toggle="modal" onClick={onCopyLink} className="dropdown-item" href="javascript:void(0);">
                                                Copy Link
                                            </a>
                                            <a className="dropdown-item" >
                                                <WhatsappShareButton id="whatsapp-share" className='whatsapp-share' url={window.location.href}>
                                                    Share on WhatsApp
                                                </WhatsappShareButton>
                                            </a>
                                        </div>
                                    </div> */}

                                    {/* <div className='common-btn'>
                                        <div className='more-btn'
                                            aria-expanded="true"
                                            aria-hidden="true"
                                            id="service_dropdown"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                        >
                                            <a>
                                                <button>Share Link</button>
                                                <img className='share-icon' src={shareIcon} alt="" />
                                            </a>
                                            <div className="right-tooltip">
                                                <div
                                                    className="dropdown-menu text-white"
                                                    aria-labelledby="service_dropdown"
                                                >
                                                    <div
                                                        className="dropdown-wrap-tool "
                                                    >
                                                        <div role={"button"} className='cursor-pointer' onClick={onCopyLink}>
                                                            Copy Link
                                                        </div>
                                                        <WhatsappShareButton id="whatsapp-share" className='whatsapp-share' url={window.location.href}>
                                                            Share on WhatsApp
                                                        </WhatsappShareButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <div className="modal-body ">
                                {showContent && <div className='user-profile-wrap'>
                                    <ImageLoader src={details?.actualAccount?.LogoURL} alt="" />
                                    <div className='user-name'>
                                        <h2>{details?.actualAccount?.PublisherName && JSON.parse('"' + String(JSON.parse('"' + details?.actualAccount?.PublisherName + '"')) + '"')}{details?.actualAccount?.DateOfBirth && (
                                            <span>
                                                (Age: {getYear(details?.actualAccount?.DateOfBirth)} {details?.actualAccount?.Gender})
                                            </span>
                                        )}</h2>
                                    </div>
                                    <div className='tags-description'>
                                        <div className='tag-container'>
                                            {!!details?.actualAccount?.Interests || !!details?.actualAccount?.Tags ? (
                                                <>
                                                    {tagsConcat(details?.actualAccount?.Interests, details?.actualAccount?.Tags)
                                                        ?.slice(0, 6)
                                                        .map((tag, tagIndex) => (
                                                            <span title={tag} key={tagIndex}>
                                                                {tag}
                                                            </span>
                                                        ))
                                                    }
                                                    {!!tagsConcat(details?.actualAccount?.Interests, details?.actualAccount?.Tags)?.slice(
                                                        6,
                                                        details?.actualAccount?.Interests?.length
                                                    ).length && <div className='more-btn'
                                                        aria-expanded="false"
                                                        aria-hidden="true"
                                                        id="service_dropdown"
                                                        data-toggle="dropdown"
                                                        aria-haspopup="true"

                                                    > {tagsConcat(details?.actualAccount?.Interests, details?.actualAccount?.Tags)
                                                        ?.length > 6
                                                        ? `+ ${tagsConcat(details?.actualAccount?.Interests, details?.actualAccount?.Tags)
                                                            .length - 6
                                                        } More`
                                                        : ""}
                                                            <div className="right-tooltip">
                                                                <div
                                                                    className="dropdown-menu"
                                                                    aria-labelledby="service_dropdown"
                                                                >
                                                                    <div className="dropdown-wrap-tool">
                                                                        {tagsConcat(details?.actualAccount?.Interests, details?.actualAccount?.Tags)
                                                                            ?.slice(
                                                                                6,
                                                                                tagsConcat(
                                                                                    details?.actualAccount?.Interests,
                                                                                    details?.actualAccount?.Tags
                                                                                )?.length
                                                                            )
                                                                            .map((tag, tagIndex) => (
                                                                                <a
                                                                                    key={tagIndex}
                                                                                    href="javascript:void(0);"
                                                                                >
                                                                                    {tag}
                                                                                </a>
                                                                            ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                </>) : (
                                                <></>
                                            )}

                                        </div>
                                    </div>
                                    <div className="detail-description">
                                        <ShowMoreText
                                            lines={4}
                                            more="Know more"
                                            less="Show less"
                                            expanded={false}
                                            truncatedEndingComponent={"... "}
                                        >
                                            {(details?.actualAccount?.Description ? codeConvert(details?.actualAccount?.Description) : "")}
                                        </ShowMoreText>
                                    </div>
                                </div>
                                }
                                {showContent ? <>
                                    {details?.actualAccount?.Accounts &&
                                        <div className='connections-wrap'>
                                            <div className='row'>
                                                <div className='col-md-5'>
                                                    {!!Object.keys(details).length && (
                                                        <div className='connection-card'>
                                                            <h2>Connection Stats</h2>
                                                            <ul>
                                                                {details?.actualAccount?.Accounts?.map((account, index) => (
                                                                    <li key={index}>
                                                                        <a
                                                                            onClick={() => viewPublisher2(account)}
                                                                        >
                                                                            {socialSection(account, "view-details")}
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className='col-md-7 d-flex justify-content-center'>
                                                    <div className='graph-wrap d-flex align-items-center'>
                                                        {series.every(item => item === 0) ? <></> :
                                                            <Chart
                                                                options={options}
                                                                series={series}
                                                                type="donut"
                                                                width={300}
                                                                height={300}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    <div className='react-tab-wrap'>
                                        <div>

                                            {!!Object.keys(details).length && (
                                                <>
                                                    <div>
                                                        <div className='audience-detail-heading'>
                                                            <div className='heading'>Key Metrics</div>
                                                        </div>
                                                        {newDetails.map((account, index) => (
                                                            <div
                                                                className={`tab-pane`}
                                                                id="profile_tab1"
                                                                role="tabpanel"
                                                                aria-labelledby="audience1"
                                                                key={index}
                                                            >
                                                                <div className="social-details-wrap key-metrics-wrap">

                                                                    <div className="soical-user-info">
                                                                        <ul>
                                                                            <li>
                                                                                <a href="javascript:void(0);"
                                                                                    onClick={() => viewPublisher3(account)}
                                                                                >
                                                                                    {socialSectionMetric(account)}
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>


                                                                    <div className="key-metrics-info-wrap">
                                                                        <div className="key-metric-card follow-data">
                                                                            {
                                                                                firstHeadingTitle(account.Network)
                                                                                    .heading
                                                                            }
                                                                            <b>
                                                                                {numberConversion(account.Followers) || "N/A"}
                                                                            </b>
                                                                        </div>
                                                                        <div className="key-metric-card">
                                                                            {
                                                                                firstHeadingTitle(account.Network)
                                                                                    .heading
                                                                            }
                                                                            <b>
                                                                                {numberConversion(account.Followers) || "N/A"}
                                                                            </b>
                                                                        </div>
                                                                        {engagementSection(account.EngagementFind)}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    <div className='audience-details-wrap'>
                                                        <div className='audience-detail-heading'>
                                                            <div className='heading'>Audience Details</div>
                                                        </div>
                                                        {/* <AudienceDetails details={details?.actualAccount} /> */}
                                                        {!_.isEmpty(selectedOption) &&
                                                            <>
                                                                <div className='audience-wrap'>
                                                                    <a href="#"><div className='social-icon'><img src={socialIcon1} alt="" /></div> <p>{selectedOption?.name} </p></a>
                                                                </div>
                                                                <div className='audience-social'>
                                                                    Active Audience: <span>{isNaN(parseFloat(activeAudience).toFixed(1)) ? 0 : parseFloat(activeAudience).toFixed(1) || 0}%</span> <div className='social-tooltip-wrap'
                                                                        aria-expanded="false"
                                                                        aria-hidden="true"
                                                                        id="service_dropdown"
                                                                        data-toggle="dropdown"
                                                                        aria-haspopup="true"

                                                                    >        <img src={Profile_tooltip} alt="" />
                                                                        <div className="right-tooltip">
                                                                            <div
                                                                                className="dropdown-menu"
                                                                                aria-labelledby="service_dropdown"
                                                                            >
                                                                                <div className="dropdown-wrap-tool">
                                                                                    <p> This is an estimated percentage of the creator's active audience. It takes into account following posts, profile picture, bios, and follower to following ratio.
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div> </>}

                                                        <div className='graph-cards-wrap'>
                                                            <div className='row justify-content-around'>
                                                                <div className='col-md-5'>
                                                                    <h2>Age</h2>
                                                                    <div className='graph-card'>
                                                                        <Chart
                                                                            options={options2}
                                                                            series={series2}
                                                                            type="bar"
                                                                            width={350}
                                                                            height={350}
                                                                        />
                                                                        {/* <img src={graphChart1} alt="" /> */}
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-5'>
                                                                    <h2 className='gender-graph'>Gender</h2>
                                                                    <div className='graph-card'>
                                                                        <Chart
                                                                            options={genderOptions}
                                                                            series={gender}
                                                                            type="pie"
                                                                            width={350}
                                                                            height={350}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-5 mx-auto mt-5'>
                                                                    <h2>Top Countries</h2>
                                                                    <div className='graph-card'>
                                                                        <Chart
                                                                            options={options3}
                                                                            series={series3}
                                                                            type="bar"
                                                                            width={350}
                                                                            height={350}
                                                                        />
                                                                        {/* <img src={graphChart1} alt="" /> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </>
                                            )}
                                        </div>
                                    </div>
                                </> : <div className="contentInfo reports-nodata">
                                    <img src={imgNoData} alt="" />
                                    <span> Information not available</span>
                                    <p>Creator has unlinked their social accounts</p>
                                </div>
                                }
                            </div>
                            {/* <div className="modal-footer">
                            <div className='common-btn'>
                                <button data-dismiss="modal">Okay</button>
                            </div>
                        </div> */}
                        </div>
                    </div>
                </div>
                {/* Social Performance Report Popup Start Here */}

            </div>
            <div className='josh-footer-wrap report-footer'>
                <div>
                    <span> Powered by</span>
                    <img src={footerLogo} alt="" />
                </div>
                <div className="reports-footer">
                    <span className="cursor-pointer" onClick={onRedirect}> Get Creator Pro</span>
                    <span className='ml-1 cursor-pointer' data-toggle="modal" data-target="#aboutus-modal"> | About Us</span>
                </div>
            </div>
            {/* About Us Popup HTML Start Here  */}
            <div className='report-about-us'>
                <div
                    className="modal fade about-us-overlay"
                    id="aboutus-modal"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    // data-backdrop="static" data-keyboard="false"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered custom-popup aboutus-popup" role="document">
                        <div className="modal-content   ">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    About Us
                                </h5>
                                <button type="button" className="close" data-dismiss="modal">
                                    <span aria-hidden="true">
                                        <img src={Close_white} alt="" />
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body ">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="aboutus-content">
                                            <div className="coin-right"><img src={leftCoin} alt="" /></div>
                                            <div className="coin-left "><img src={rightCoin} alt="" /></div>
                                            <p>How do I earn money using my social accounts? </p>
                                            <span>CreatorPro is the solution. Link your social accounts and get access to exciting monetization opportunities.</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="about-OwlCarousel">
                                            <OwlCarousel
                                                className="owl-theme"
                                                loop={true}
                                                margin={20}
                                                nav={false}
                                                autoWidth={false}
                                                autoplay={true}
                                                responsive={{
                                                    0: {
                                                        items: 1,
                                                        stagePadding: 0,
                                                    },
                                                    600: {
                                                        items: 1,
                                                        stagePadding: 30,
                                                    },
                                                    1000: {
                                                        items: 1,
                                                    },
                                                }}
                                            >
                                                <div className="item">
                                                    <div className="aboutus-slider-wrap">
                                                        <div className="aboutus-slider-card">
                                                            <img src={aboutSlider1} alt="" />
                                                            <p>45+ performance metrics tracked in one place </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="item">
                                                    <div className="aboutus-slider-wrap">
                                                        <div className="aboutus-slider-card">
                                                            <img src={aboutSlider2} alt="" />
                                                            <p>10000+ brands are waiting for colloborations </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="item">
                                                    <div className="aboutus-slider-wrap">
                                                        <div className="aboutus-slider-card">
                                                            <img src={aboutSlider3} alt="" />
                                                            <p>Connect more accounts and monitor your performance</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="item">
                                                    <div className="aboutus-slider-wrap">
                                                        <div className="aboutus-slider-card">
                                                            <img src={aboutSlider4} alt="" />
                                                            <p>Choose from 20000+ affiliate products</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </OwlCarousel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className="footer-text">
                                    Join 10,000+ creators who are using Creator PRO now!
                                    <div className="login-otp-wrap">
                                        <div className="common-btn">
                                            <button
                                                onClick={() => {
                                                    localStorage.setItem("isLoginPopup", true)
                                                    window.open("/", '_blank')
                                                }}
                                                data-dismiss="modal" >Login with OTP</button>
                                        </div>
                                        <div className="or-class"> <span>OR</span> </div>
                                        <ul>
                                            {/* <li>
                                            <LoginSocialApple
                                                client_id={process.env.REACT_APP_APPLE_ID}
                                                scope={'email'}
                                                redirect_uri={REDIRECT_URI}
                                                onResolve={({ provider, data }) => {
                                                    console.log("123provider, data ", provider, data)
                                                    onLoginResolve(provider, data?.authorization?.id_token, data.authorization.code)
                                                }}
                                                onReject={err => {
                                                    console.log(err);
                                                }}
                                            >
                                                <img src={aboutIocon1} className="cursor-pointer" alt="" />
                                            </LoginSocialApple></li> */}
                                            <li>
                                                <GoogleLogin
                                                    theme="filled_blue"
                                                    shape="circle"
                                                    type="icon"
                                                    auto_select={false}
                                                    onSuccess={(credentialResponse) => {
                                                        console.log("123credentialResponse", credentialResponse);
                                                        onLoginResolve("GOOGLE", credentialResponse?.credential)
                                                    }}
                                                    onError={() => {
                                                        console.log('Login Failed');
                                                    }}
                                                />
                                            </li>
                                            <li>
                                                <LoginSocialFacebook
                                                    appId={process.env.REACT_APP_FB_APP_ID}
                                                    fieldsProfile={
                                                        'id,first_name,last_name,middle_name,name,name_format,picture,short_name,email,gender'
                                                    }
                                                    redirect_uri={REDIRECT_URI}
                                                    onResolve={({ provider, data }) => {
                                                        console.log("123provider, data ", provider, data)
                                                        onLoginResolve(provider, data?.accessToken)
                                                    }}
                                                    onReject={err => {
                                                        console.log(err);
                                                    }}
                                                >
                                                    <img className="cursor-pointer" src={aboutIocon3} alt="" />
                                                </LoginSocialFacebook>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* About Us Popup HTML Start Here  */}
        </>
    )
}


export default IsLoadingHOC(SocialPerformanceReport)
